import type { ZodSchema } from '@vy/utils';
import type { FormDrawerProps } from '../../FormDrawer';
import { NetSuiteFooter } from './components/NetSuiteFooter';
import { NetsuiteRegistrationForm } from './components/NetSuiteRegistrationForm';
import type { NetSuiteRegisterFormValues } from './NetsuiteRegisterFormSchema';
import { NetSuiteRegisterFormSchema } from './NetsuiteRegisterFormSchema';

export const RegisterToNetsuiteComponents: FormDrawerProps<ZodSchema<NetSuiteRegisterFormValues>> = {
  zodSchema: NetSuiteRegisterFormSchema,
  ContentComponent: NetsuiteRegistrationForm,
  Footer: NetSuiteFooter,
};
